var map = {
	"./ar-sa.json": "7db2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./ja.json": "0423",
	"./km.json": "5153",
	"./ko.json": "dd11",
	"./mn.json": "7bf5",
	"./ms.json": "2060",
	"./my.json": "3ecc",
	"./ru.json": "7704",
	"./th.json": "8680",
	"./vi.json": "aced",
	"./zh-cn.json": "2c61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";